import React from 'react';
import { clsx } from 'clsx';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'neutral' | 'success' | 'warning' | 'error' | 'brand';
}
export function Badge({
  className,
  variant = 'neutral',
  children,
  ...props
}: BadgeProps) {
  const variants = {
    neutral: 'bg-[#F5F5F5] text-[#706E6B] border-[#E5E5E5]',
    success: 'bg-[#04844B]/10 text-[#04844B] border-[#04844B]/20',
    warning: 'bg-[#FF9A3C]/10 text-[#B86800] border-[#FF9A3C]/20',
    error: 'bg-[#EA001E]/10 text-[#EA001E] border-[#EA001E]/20',
    brand: 'bg-[#0176D3]/10 text-[#0176D3] border-[#0176D3]/20'
  };
  return <span className={clsx('inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium border', variants[variant], className)} {...props} data-id="element-280">
      {children}
    </span>;
}